<loading-dots *ngIf="loadingService.loadingStatus"></loading-dots>
<router-outlet></router-outlet>